import { gql } from '@apollo/client';

export default gql`
  query me {
    me {
      paymentCurrencies
      canOverrideFees @client
      offices {
        name
        description
        defaultPaymentLocation
        isStation
      }
      permissions
      organization {
        code
      }
    }
  }
`;
